
import { useEffect, useState } from 'react';
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import DataTable from 'react-data-table-component';
import LocalMsgModalSpinner from '../../../../components/LocalMsgModalSpinner';
import MsgModalDialogEspecial from '../../../../components/MsgModalDialogEspecial';
import * as env from '../../../../env';
import { httpApiGetText } from '../../../../lib';
import { exportToExcel } from '../../../../util';

const MsgDialogReconteoRepoInv = (
            props: {Show: boolean, Title: string, BtnOkName: string, 
            BtnNokName: string, data:any, formData: any;
            HandlerClickOk: any, HanlerdClickNok: any}) =>{

  let [records, setRecords] = useState([]);
  const [sHCarga, setSHCarga] = useState(false);  
  const [msgDlgShowApiResponse, setMsgDlgShowApiResponse] = useState(false); 
  const [msgApiResponse, setMsgApiResponse] = useState("");  

  let columns = [
    { name: "Anterior Físico", selector: (row:any) => row.Anterior_fisico,  format: (row:any) => row.Anterior_fisico.toLocaleString(),  sortable: true, right: true,  width:"150px"},
    { name: "Anterior SAP", selector: (row:any) => row.Anterior_sap,  format: (row:any) => row.Anterior_sap.toLocaleString(), sortable: true, width:"150px", right: true},
    { name: "Bajada Saldos", selector: (row:any) => row.Bajada_saldos, width:"180px", sortable: true},
    { name: "Nuevo Físico", selector: (row:any) => row.Nuevo_fisico, format: (row:any) => row.Nuevo_fisico.toLocaleString(), sortable: true, width:"150px", right: true},
    { name: "Nuevo SAP", selector: (row:any) => row.Nuevo_sap, right: true, format: (row:any) => row.Nuevo_sap.toLocaleString(), sortable: true, width:"150px"}, 
    { name: "Fecha Publicación", selector: (row:any) => row.Publicado_fecha, sortable: true, width:"180px"},
    { name: "Usuario Publicado", selector: (row:any) => row.Publicado_usuario, sortable: true, width:"150px"},
    { name: "Reconteo Referencia", selector: (row:any) => row.Reconteo_ref, format: (row:any) => row.Reconteo_ref.toLocaleString(), right: true, sortable: true, width:"200px"},        
    { name: "Usuario Apertura", selector: (row:any) => row.Usuario_apertura, sortable: true, width:"150px"},          
  ]

  const pagOptions = {
      rowsPerPageText: "Filas por páginas",
      rangeSeparatorText: "de",
      selectAllRowsItem: true,
      selectAllRowsItemText: "Todos"
  }; 

  useEffect(()=>{

    const llamadaApi = async () =>{
      setSHCarga(true);
      const recurso = `${env.REACT_APP_API_URL}/api/ReporteInventarioCentro?Pais=CL&Anno=${props.formData.Anno}&Mes=${props.formData.Mes}` + 
                      `&Centro=${props.formData.Centro}&Almacen=${props.formData.Almacen}&Inv_item_id=${props.data.Codigo}&Especial=`; 
      const response = await httpApiGetText(recurso, {
        'Content-Type': 'application/json',
        'Rosen-API-Key': `${env.REACT_APP_Rosen_API_Key}`,
        'Rosen-API-Secret': `${env.REACT_APP_Rosen_API_Secret}`,
    });
      const arrDta = await JSON.parse(response.message); 
      setSHCarga(false);      
      if (response.code >= 400){
        setMsgApiResponse(arrDta.Message);
        setMsgDlgShowApiResponse(true);
      }else{
        const auxDta:any = [];
        arrDta.map((obj: any, index: number)=>{
          const newObj = {...obj};
          auxDta.push(newObj);
        });
        setRecords(auxDta);
        setSHCarga(false);        
      }
    }

    if (props.Show){
      llamadaApi();
    }
  }, [props.Show]);

  const MsgDlghandlerResponseApi = () =>{
    setMsgDlgShowApiResponse(false);
  }

return(
    <>
      <Modal show={props.Show} size="xl" centered>
        <Modal.Header >
          <Modal.Title>{props.Title}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
            <div>{`Descripción: ${props.data.Codigo} - ${props.data.Descripcion}`}</div>
            <div className='mt-3'>
                <div>
                    <Button className="btn btn-success" onClick={()=>{ 
                            if (records.length > 0 )
                              exportToExcel("tablaAvanceDetalle", records)
                            }
                         }>Exportar</Button>
                    <div>
                        <DataTable
                            columns={columns}
                            data={records}
                            selectableRowsHighlight
                            fixedHeader
                            pagination
                            highlightOnHover
                            fixedHeaderScrollHeight="600px"
                            paginationComponentOptions={pagOptions}
                        />                      
                    </div>
                </div>
            </div>
        </Modal.Body>
        <Modal.Footer>
          <Button  onClick={props.HandlerClickOk} className="btn btn-success">
            {props.BtnOkName}
          </Button>          
          <Button onClick={props.HanlerdClickNok} className="btn btn-secondary">
            {props.BtnNokName}
          </Button>
        </Modal.Footer>
      </Modal>
      {/*********** cuadro de dialogo para msj de api **********/}
      <MsgModalDialogEspecial
          Show={msgDlgShowApiResponse}
          Title={`Reporte Inventario - Reconteo`}
          Icon="x"
          Message={msgApiResponse}
          BtnOkName="Aceptar"
          BtnNokName=""
          HandlerClickOk={MsgDlghandlerResponseApi}
          HanlerdClickNok={null}
      />        
      <LocalMsgModalSpinner 
                    Show={sHCarga}
                    text="Un momento por favor, verificando detalle..."
                    color="#FF7588"
        />        
    </>
)

}

export default MsgDialogReconteoRepoInv;
